import { consoleRedirectUrl, consoleUrlReg } from '../../../../global';

export const SeoLinksHeader = () => (
  <>
    <a href="/calculator">Калькулятор цен</a>
    <a href="/documents/tariffs/index.html">Тарифы</a>
    <a href="/offers">Акции</a>
    <a href="/docs/index.html">Документация</a>
    <a href="/about">О нас</a>
    <a href="/career">Карьера в Cloud.ru</a>
    <a href="/news">Новости</a>
    <a href="/documents/">Юридические документы</a>
    <a href="/contacts">Контакты</a>
    <a href="/solutions">Решения</a>
    <a href="/partners/referral">Реферальная программа</a>
    <a href="/cases">Кейсы</a>
    <a href="/partners">Партнерство с Cloud.ru</a>
    <a href="/security">Безопасность</a>
    <a href="/evolution">Evolution</a>
    <a href="/advanced">Advanced</a>
    <a href="/evolution-stack">Evolution Stack</a>
    <a href="/vmware">Облако VMware</a>
    <a href="/mlspace">ML Space</a>
    <a href="/platforms-comparison">В чем отличия платформ?</a>
    <a href="/blog">Блог</a>
    <a href="/education">Обучение и сертификация</a>
    <a href="/events">Мероприятия</a>
    <a href="/issledovanie-oblachnye-tehnologii">Исследования Cloud.ru</a>
    <a href={consoleRedirectUrl}>Личный кабинет</a>
    <a href={consoleRedirectUrl}>Войти</a>
    <a href={consoleUrlReg}>Зарегистрироваться</a>
  </>
);
